import $ from 'jquery';

import application from 'application/application';
import moment from 'moment';
moment.locale('pt-BR');

import 'air-datepicker/dist/js/datepicker';

const LABELS_DEFINITIONS = {
	days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
	daysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
	daysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	months: [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro'
	],
	monthsShort: [
		'Jan',
		'Fev',
		'Mar',
		'Abr',
		'Mai',
		'Jun',
		'Jul',
		'Ago',
		'Set',
		'Out',
		'Nov',
		'Dez'
	],
	today: 'Hoje',
	clear: 'Limpar'
};

$.fn.datepicker.language['pt-BR'] = {
	...LABELS_DEFINITIONS,
	dateFormat: 'dd/mm/yyyy',
	timeFormat: 'hh:ii aa',
	firstDay: 0,
	range: true,
	multipleDatesSeparator: ' até '
};

application.directive('airDatepickerRange', [
	'$rootScope',
	'$stateParams',
	($rootScope, $stateParams) => {
		return {
			scope: {
				defaultText: '@',
				defaultWidth: '@',
				displayText: '@',
				minWidth: '@',
				maxWidth: '@',
				datepickerStyle: '@',
				isMobile: '@',
				minDate: '@',
				maxDate: '@'
			},
			link: (scope, element) => {
				$rootScope.dateMovements = [];
				scope.dateArr = [];
				scope.lastDates = [];

				scope.updateDisplay = newValue => {
					if (newValue == 'Todos períodos') {
						element.css('width', '130px');
						$(element).val(newValue);
						$rootScope.dataSelecionada = false;
						$rootScope.periodsFolderTypeSelected = false;
					} else if (newValue == 'Período - últimos 15 dias') {
						element.css('width', '190px');
						$(element).val(newValue);
						$rootScope.dataSelecionada = false;
						$rootScope.periodsFolderTypeSelected = false;
					} else if (newValue == 'Escolher período') {
						element.css('width', '150px');
						$(element).val(newValue);
						$rootScope.dataSelecionada = false;
						$rootScope.periodsFolderTypeSelected = false;
					} else if (newValue && newValue.contains('até')) {
						element.css('width', '210px');
						$(element).val(newValue);
						$rootScope.dataSelecionada = true;
					} else if (newValue && newValue.contains('/')) {
						element.css('width', '130px');
						$(element).val(newValue);
						$rootScope.dataSelecionada = true;
					} else if (newValue != undefined) {
						element.css('width', scope.defaultWidth);
						$(element).val(scope.defaultText);
					}

					if (scope.isMobile == 'true' || scope.isMobile == true) {
						element.css('width', '100%');
					}
				};

				if (
					$stateParams &&
					$rootScope.params &&
					$rootScope.params.dataInicial &&
					$rootScope.params.dataFinal
				) {
					$rootScope.dateMovements[0] = moment(
						new Date($rootScope.params.dataInicial).setHours(0, 0)
					).format('YYYY-MM-DDTHH:mm:ss');
					$rootScope.dateMovements[1] = moment(
						new Date($rootScope.params.dataFinal).setHours(23, 59)
					).format('YYYY-MM-DDTHH:mm:ss');

					const formattedDate =
						moment(
							new Date($rootScope.params.dataInicial).setHours(0, 0)
						).format('DD/MM/YYYY') +
						' até ' +
						moment(
							new Date($rootScope.params.dataInicial).setHours(23, 59)
						).format('DD/MM/YYYY');

					$(element).val(formattedDate);
				} else {
					$(element).val('Período - últimos 15 dias');
				}

				if (
					$rootScope.$$phase !== '$apply' &&
					$rootScope.$$phase !== '$digest'
				) {
					$rootScope.$apply();
				}

				const { ArrowButton } = Components();

				const datepickerMinRange =
					scope.minDate && scope.minDate != 'Invalid date'
						? new Date(scope.minDate)
						: undefined;
				const datepickerMaxRange =
					scope.maxDate && scope.maxDate != 'Invalid date'
						? new Date(scope.maxDate)
						: undefined;

				const datepickerInstance = $(element)
					.datepicker({
						language: 'pt-BR',
						autoClose: true,
						prevHtml: ArrowButton('back'),
						nextHtml: ArrowButton('forward'),
						startDate: null,
						range: true,
						minDate: datepickerMinRange,
						maxDate: datepickerMaxRange,
						multipleDatesSeparator: ' até ',
						onSelect: (formattedDate, date) => {
							if (scope.lastDates.length > 3) {
								scope.lastDates = scope.lastDates.slice(0, 2);
							}

							if (scope.lastDates.length >= 1) {
								if (
									date.length == 0 &&
									scope.lastDates[0].length == 1 &&
									(!scope.lastDates[1] ||
										(scope.lastDates[1] &&
											moment(new Date(scope.lastDates[0][0])).format(
												'YYYY-MM-DD'
											) !==
												moment(new Date(scope.lastDates[1][0])).format(
													'YYYY-MM-DD'
												) &&
											moment(new Date(scope.lastDates[0][0])).format(
												'YYYY-MM-DD'
											) !==
												moment(new Date(scope.lastDates[1][1])).format(
													'YYYY-MM-DD'
												)))
								) {
									formattedDate =
										moment(new Date(scope.lastDates[0][0])).format(
											'DD/MM/YYYY'
										) +
										' até ' +
										moment(new Date(scope.lastDates[0][0])).format(
											'DD/MM/YYYY'
										);
									date = [];
									date[0] = scope.lastDates[0][0];
									date[1] = new Date(scope.lastDates[0][0]).setHours(
										23,
										59,
										59
									);
								}
							}

							scope.lastDates.unshift(date);

							let dataFinalPadrao = new Date();
							let dataInicialPadrao = new Date();

							dataFinalPadrao.setHours(23, 59, 59);
							dataInicialPadrao.setDate(dataFinalPadrao.getDate() - 14);
							dataInicialPadrao.setHours(0, 0, 0);

							let dataPadrao = false;

							if (
								date.length === 2 &&
								moment(new Date(date[0])).format('YYYY-MM-DD') ===
									moment(new Date(dataInicialPadrao)).format('YYYY-MM-DD') &&
								moment(new Date(date[1])).format('YYYY-MM-DD') ===
									moment(new Date(dataFinalPadrao)).format('YYYY-MM-DD') &&
								($rootScope.pageSelected == 'Key' ||
									$rootScope.pageSelected == 'pastaPubli' ||
									$rootScope.pageSelected == 'Int')
							) {
								dataPadrao = true;
								$rootScope.dateMovements = [];
								date = [];
								formattedDate = 'Período - últimos 15 dias';
								scope.displayText = formattedDate;
								scope.updateDisplay(formattedDate);
								$rootScope.$emit('air-datepicker-range-change', {
									date: [],
									formattedDate: formattedDate,
									defaultDate: true
								});
							}

							if (date.length === 2 && !dataPadrao) {
								if (
									$rootScope.pageSelected == 'Key' ||
									$rootScope.pageSelected == 'pastaPubli'
								) {
									$stateParams.periodsFolderTypeSelected = true;
									$rootScope.periodsFolderType = false;
									localStorage.setItem('__allowFilters__', true);
								}

								$rootScope.dateMovements[0] = moment(
									new Date(date[0]).setHours(0, 0)
								).format('YYYY-MM-DDTHH:mm:ss');
								$rootScope.dateMovements[1] = moment(
									new Date(date[1]).setHours(23, 59, 59)
								).format('YYYY-MM-DDTHH:mm:ss');

								if (formattedDate) scope.displayText = formattedDate;
							}

							if (date.length === 1) {
								$rootScope.dateMovements[0] = moment(
									new Date(date[0]).setHours(0, 0)
								).format('YYYY-MM-DDTHH:mm:ss');
								$rootScope.dateMovements[1] = moment(
									new Date(date[0]).setHours(23, 59, 59)
								).format('YYYY-MM-DDTHH:mm:ss');

								if (formattedDate) scope.displayText = formattedDate;
							}

							if (date.length === 0) {
								$rootScope.dateMovements = [];
							}

							if (!dataPadrao || $rootScope.pageSelected == 'Int') {
								$rootScope.$emit('air-datepicker-range-change', {
									date: date,
									formattedDate: formattedDate,
									defaultDate: dataPadrao
								});

								if (date.length == 2) {
									$(element).trigger('blur');
								}
							}

							if (!$rootScope.pageSelected) {
								scope.updateDisplay();
							}

							if (
								$rootScope.$$phase !== '$apply' &&
								$rootScope.$$phase !== '$digest'
							) {
								$rootScope.$apply();
							}

							// if (scope.$$phase !== '$apply' && scope.$$phase !== '$digest') {
							// 	scope.$apply();
							// }
						},
						onShow: datepicker => {
							setTimeout(() => {
								$rootScope.isAirDatepickerRangeOpen = true;
							}, 400);

							setTimeout(() => {
								$('.datepicker').addClass('datepicker-range');
							}, 10);

							const displayedText = $(element).val();

							if (!displayedText.contains('/')) {
								datepicker.clear();
							}
						},
						onHide: () => {
							if ($rootScope.isAirDatepickerRangeOpen) {
								$rootScope.isAirDatepickerRangeOpen = false;
							} else {
								setTimeout(() => {
									$rootScope.isAirDatepickerRangeOpen = false;
								}, 200);
							}
						},
						updateDisplay: newValue => {
							scope.updateDisplay(newValue);
						}
					})
					.data('datepicker');

				scope.$watch('minWidth', newValue => {
					element.css('min-width', newValue);
				});
				scope.$watch('maxWidth', newValue => {
					element.css('max-width', newValue);
				});
				scope.$watch('displayText', newValue => {
					scope.updateDisplay(newValue);
				});
				scope.$watch('datepickerStyle', newValue => {
					if (
						!!newValue &&
						newValue.length > 6 &&
						newValue.includes('{') &&
						newValue.includes('}')
					) {
						const values = JSON.parse(newValue);

						for (const key in values) {
							element.css(key, values[key]);
						}
					}
				});
				scope.$watch('isMobile', () => {
					scope.updateDisplay(scope.displayText);
				});

				if (
					$stateParams &&
					$rootScope.params &&
					$rootScope.params.dataInicial &&
					$rootScope.params.dataFinal
				) {
					setTimeout(() => {
						const initialDate = moment(
							new Date($rootScope.params.dataInicial).setHours(0, 0)
						).format('DD/MM/YYYY');
						const finalDate = moment(
							new Date($rootScope.params.dataFinal).setHours(23, 59)
						).format('DD/MM/YYYY');

						datepickerInstance.opts.onSelect(
							'' + initialDate + ' até ' + finalDate + '',
							[
								new Date($rootScope.params.dataInicial),
								new Date($rootScope.params.dataFinal)
							],
							datepickerInstance
						);
					}, 10);
				}

				element.css({
					'min-width': scope.minWidth || 'auto',
					'max-width': scope.maxWidth || 'auto'
				});
			}
		};
	}
]);

function Components() {
	const components = {
		DayCell: ({ day } = {}) => `<span aria-highlited-day="false">${day}</span>`,
		YearCell: ({ year } = {}) =>
			`<span aria-highlited-day="false">${year}</span>`,
		MonthCell: ({ month, datepicker } = {}) =>
			LABELS_DEFINITIONS[datepicker.opts.monthsField][month],
		ArrowButton(side) {
			return `
				<button type="button" class="btn btn-link">
					<i class="material-icons" aria-hidden="true">arrow_${side}</i>
				</button>
			`;
		},
		HighlitedDayCell({ day } = {}) {
			return `
				<div class="highlited-day" aria-highlited-day="true">
					<div class="highlited-day__text">
						${day}
					</div>
					<div class="highlited-day__dot fadeIn">
						<span class="calendar-square"></span>
					</div>
				</div>
			`;
		}
	};

	Object.keys(components).forEach(
		componentName => (Components[componentName] = components[componentName])
	);

	return components;
}
